import React, { useState } from 'react';
import { connectHits } from 'react-instantsearch-dom';
import GoogleMapReact from 'google-map-react';

import LocationListingMapPin from './LocationListingMapPin';

const LocationListingMapHits = props => {
    const { hits } = props;
    const [activeInfoWindow, setActiveInfoWindow] = useState('');

    return (
        <div className="location-listing-map-container">
            <GoogleMapReact
                bootstrapURLKeys={{ key: 'AIzaSyA_1xDTM9H4HOpeTDWz6N6B0p6r2oJElME' }}
                defaultCenter={{ lat: -28.024, lng: 140.887 }}
                defaultZoom={5}
            >
                {hits && hits.length > 0 && hits.map(hit => {
                    // eslint-disable-next-line no-underscore-dangle
                    if (!hit._geoloc) {
                        return null;
                    }
                    return (
                        <LocationListingMapPin
                            key={hit.objectID}
                            lat={hit._geoloc.lat} // eslint-disable-line no-underscore-dangle
                            lng={hit._geoloc.lng} // eslint-disable-line no-underscore-dangle
                            hit={hit}
                            infoWindowActive={activeInfoWindow === hit.objectID}
                            handleInfoWindow={(value: string) => setActiveInfoWindow(value)}
                        />
                    );
                })}
            </GoogleMapReact>
        </div>
    );
};

export default connectHits(LocationListingMapHits);
